<template>
  <v-container>
    <v-progress-linear indeterminate color="cyan" v-if="loading"></v-progress-linear>

    <div v-if="offers">
      <v-row>
        <v-col
          v-for="(offer, index) in offers"
          :key="category + offer.id + index"
          class="my-2"
          style="display: flex; justify-content: space-between;"
        >
          <span>
            <v-img
              :src="merchantLogo(offer.merchant)"
              style="border-radius: 50%; border: 1px solid #3F51B5; width: 60px; background-color: grey;"
            />
          </span>
        </v-col>
      </v-row>
    </div>

    <div v-else>No offers to show!</div>
  </v-container>
</template>

<script>
export default {
  props: ["category", "offers", "loading"],

  data() {
    return {};
  },

  methods: {
    merchantLogo(merchant) {
      return `https://snapsales-images.s3-eu-west-1.amazonaws.com/merchant/${merchant.id}_${merchant.logo}`;
    }
  }
};
</script>

<style lang="scss" scoped></style>
